import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-1" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--caption gfu-hd--uppercase _ttu _fw-n _ma-0" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_admin_router_link = _resolveComponent("admin-router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, [
      _createTextVNode(_toDisplayString($props.title) + " ", 1 /* TEXT */),
      (!!$props.tooltip)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            text: $props.tooltip,
            "icon-name": "circle-info"
          }, null, 8 /* PROPS */, ["text"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("h4", _hoisted_3, _toDisplayString($props.value), 1 /* TEXT */),
    ($options.actionRoute)
      ? (_openBlock(), _createBlock(_component_admin_router_link, {
          key: 0,
          to: $options.actionRoute,
          class: "_tc--accent"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.actionLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]))
      : _createCommentVNode("v-if", true)
  ]))
}